import React from 'react';
import { inject } from 'mobx-react';
import { Callout } from 'core/components';
import CloudMetadata from 'app/views/hybrid/maps/components/popovers/CloudMetadata';

import SidebarItem from '../SidebarItem';
import DrgRouteDistribution from './components/DrgRouteDistribution';

const DrgRouteTablePopover = ({ width, popoutTitle, $hybridMap, ...rest }) => {
  const { nodeData } = rest;
  const { ociCloudMapCollection } = $hybridMap;

  const { drgRouteTableId } = nodeData;

  if (!drgRouteTableId) {
    return null;
  }

  const drgRouteTable = ociCloudMapCollection.findEntityById(drgRouteTableId);
  if (!drgRouteTable) {
    return (
      <SidebarItem title="DRG Route Table" icon="route" {...rest}>
        <Callout intent="danger" p={2} position="relative">
          Unable to find DRG Route Table in topology
        </Callout>
      </SidebarItem>
    );
  }

  const drgRouteDistribution = ociCloudMapCollection.findEntityById(drgRouteTable.importDrgRouteDistributionId);
  if (!drgRouteDistribution) {
    return null;
  }

  const cloudMetadataDetails = {
    node: {
      ...drgRouteTable,
      Name: drgRouteTable.displayName,
      Status: drgRouteTable.lifecycleState,
      'Created At': new Date(drgRouteTable.timeCreated).toLocaleString()
    },
    keys: ['id', 'Name', 'region', 'Status', 'Created At', 'compartmentId', 'tenancyId']
  };

  return (
    <>
      <SidebarItem title="DRG Route Table" icon="route" {...rest}>
        <CloudMetadata {...cloudMetadataDetails} />
      </SidebarItem>
      <DrgRouteDistribution nodeData={drgRouteDistribution} width={width} popoutTitle={popoutTitle} />
    </>
  );
};

export default inject('$hybridMap')(DrgRouteTablePopover);
